/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Holdings_None_LeftInputs */



/**
* | output |
* | --- |
* | "none left" |
*
* @param {Promo_Holdings_None_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_holdings_none_left = /** @type {((inputs?: Promo_Holdings_None_LeftInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Holdings_None_LeftInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("aucune restante")
	if (locale === "es") return /** @type {LocalizedString} */ ("ninguna restante")
	if (locale === "pt") return /** @type {LocalizedString} */ ("nenhuma restante")
	if (locale === "it") return /** @type {LocalizedString} */ ("nessuna rimanente")
	return /** @type {LocalizedString} */ ("none left")
});